// Issue #72: アプリ全体設定（AI 壁打ち機能の有効/無効）を取得する
// secureApi は使わない（401 時に /login へリダイレクトするため）。素の axios を使う。
import axios from "axios";
import { API_URL } from "../utils/apiUtils";

// Issue #171: ページ遷移・タブ復帰のたびに再取得するため、永続キャッシュは持たない。
// 同時に呼ばれた場合のみ実行中（in-flight）の Promise を共有して HTTP を 1 本に集約する。
// 失敗時は reject する（初回なら無効扱い／2 回目以降は直前値維持の判断は Context 側で行う）。
let inFlight = null;

export const fetchAppSettings = () => {
  if (!inFlight) {
    inFlight = axios
      .get(`${API_URL}/app-settings`)
      .then((response) => ({
        aiEnabled: response?.data?.aiEnabled === true,
      }))
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
};
